import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUncheckedSharp';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonCheckedSharp';

export default function LPBRadioFilters({onFilterChange }) {
    const [selectedValue, setSelectedValue] = React.useState('rgSale');

    const handleChange = name => event => {
        setSelectedValue(event.target.value);
        onFilterChange(name, event.target.checked); 
    };

    return (
        <div style={{ textAlign: "left" }}>
            Sale<Radio
                checked={selectedValue === 'rgSale'}
                onChange={handleChange('rgSale')}
                value="rgSale"
                name="rgSale"
                inputProps={{ 'aria-label': 'Sale' }}
                color="primary"
                icon={<RadioButtonUncheckedIcon fontSize="small" />}
                checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
            />
            Private<Radio
                checked={selectedValue === 'rgPrivate'}
                onChange={handleChange('rgPrivate')} 
                value="rgPrivate"
                name="rgPrivate"
                inputProps={{ 'aria-label': 'Private' }}
                color="primary"
                icon={<RadioButtonUncheckedIcon fontSize="small" />}
                checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
            />
            Multi-Transfer<Radio
                checked={selectedValue === 'rgTransfer'}
                onChange={handleChange('rgTransfer')} 
                value="rgTransfer"
                name="rgTransfer"
                inputProps={{ 'aria-label': 'Transfer' }}
                color="primary"
                icon={<RadioButtonUncheckedIcon fontSize="small" />}
                checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
            /> 
        </div>
    );
}